'use strict';

import ko from 'knockout';

ko.bindingHandlers.init = {
  init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
    let data = ko.unwrap(valueAccessor()), $data = bindingContext.$data;
    for (let key in data) {
      if (ko.isObservable($data[key])) {
        $data[key](data[key]);
      }
    }
  }
};



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/scripts/handlers/init.babel.js
 **/